// extracted by mini-css-extract-plugin
export var navbarItem = "navbar-module--navbar-item--LSKXu";
export var navbarItemActive = "navbar-module--navbar-item-active--deL3H";